import React from 'react'
import { TableHead, TableRow, TableCell, withStyles } from '@material-ui/core'
import styles from './styles'

const TableHeadComponent = props => {
  const { category, classes } = props
  return (
    <TableHead>
      <TableRow>
        <TableCell className={classes.headerTableCell2}>
          {category.category}
        </TableCell>
        <TableCell className={classes.headerTableCell}>
          {category.category === 'Creating' ? 'Basic' : ''}
        </TableCell>
        <TableCell className={classes.headerTableCell}>
          {category.category === 'Creating' ? 'Pro' : ''}
        </TableCell>
        <TableCell className={classes.headerTableCell}>
          {category.category === 'Creating' ? 'Elite' : ''}
        </TableCell>
      </TableRow>
    </TableHead>
  )
}

export default withStyles(styles)(TableHeadComponent)
